import React from 'react';
import moment from 'moment';
import { useTypedSelector } from '@hooks';
import { MdWidth } from '@components/Responsive';
import DropdownAssetVersions from '@components/MediaViewerHeader/components/DropdownAssetVersions';

import { ReactComponent as EyePrivateSvg } from '@assets/icons/MediaViewer/eye-private.svg';
import { Avatar, Tooltip } from 'antd';
import { useAuth } from '@hooks/useAuth';
import { hashedColor } from '@helpers/hashedColor';
import UserAvatarLetters from '@helpers/userAvatarLetters';

moment.updateLocale('en', {
  relativeTime: {
    past: '%s ago',
    s: 'second',
    ss: '%s seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  }
});

function AssetInfo() {
  const { user } = useAuth();
  const isInternal = user?.type === 'internal';
  const selectedVersion = useTypedSelector(
    ({ mediaViewer }) => mediaViewer.selectedVersion
  );
  const assets = useTypedSelector(({ mediaViewer }) => mediaViewer.assets);
  const isPrivate =
    !!assets?.isPrivate || !assets?.path.some((x) => x.isPrivate);

  return (
    <div className="description">
      <div className="title">
        <div className="name">
          <Tooltip
            title={`${selectedVersion?.name}.${selectedVersion?.extension}`}
            overlayClassName="toggle_favorite_overlay  toggle_favorite_overlay--small"
          >
            <span>{selectedVersion?.name}</span>
          </Tooltip>
        </div>
        <div className="ext">{selectedVersion?.extension}</div>
        <MdWidth>
          {(assets?.asset?.versions?.length ?? 0) > 1 ? (
            <DropdownAssetVersions external={!isInternal} />
          ) : (
            <div className="ext">V{selectedVersion?.versionNumber || 1}</div>
          )}
        </MdWidth>
        {isPrivate && <EyePrivateSvg className="icon-eye" />}
      </div>
      <div className="info">
        <div className="info-avatar">
          <Avatar
            src={selectedVersion?.user?.picture.url}
            style={{
              color: '#161819',
              fontWeight: 'bold',
              backgroundColor: hashedColor(
                selectedVersion?.user?.email ?? '',
                'mediaViewerComment'
              )
            }}
          >
            {UserAvatarLetters(selectedVersion?.user?.name)}
          </Avatar>
        </div>
        <div className="info-body">
          <p className="info-body-name">{selectedVersion?.user?.name}</p>
          <p className="info-body-meta">
            {moment(selectedVersion?.createdAt).fromNow()}
          </p>
        </div>
      </div>
    </div>
  );
}

export default AssetInfo;
